export default __webpack_public_path__ + "static/media/emptyImage.c3f94521.png";